/**
 * @Author: abbeymart | Abi Akindele | @Created: 2020-09-25
 * @Company: Copyright 2020 Abi Akindele  | mConnect.biz
 * @License: All Rights Reserved | LICENSE.md
 * @Description: mc-central-ts: business routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const legalRoutes: Array<RouteRecordRaw> = [
  {
    path: '/policies',
    name: 'policies',
    redirect: '/policies/terms',
    component: () => import('pages/mc/McPage.vue'),
    meta: {
      title: 'mConnect Policies',
    },
    children: [
      {
        path: 'terms',
        name: 'terms',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Terms of Service',
        },
      },
      {
        path: 'privacy',
        name: 'privacy',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Privacy Policy',
        },
      },
      {
        path: 'conduct',
        name: 'conduct',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'Code of Conduct',
        },
      },
      {
        path: 'paidterms',
        name: 'paidterms',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'mConnect Paid Services Terms',
        },
      },
      {
        path: 'freeterms',
        name: 'freeterms',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'mConnect Open Source - Free Services',
        },
      },
      {
        path: 'dispute',
        name: 'dispute',
        component: () => import('pages/mc/McPage.vue'),
        meta: {
          title: 'mConnect Dispute Resolution',
        },
      },
    ],
  },
];
